import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'
import isString from 'lodash/isString'

import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  label: string
  value?: string | number | null
}

interface ValueProps {
  value?: string | number | null
}

const Value = ({ value }: ValueProps) => {
  if (isNil(value)) {
    return (
      <Text color="grey000White" weight="medium" size="200">
        -
      </Text>
    )
  }
  if (isString(value)) {
    return (
      <Text color="grey000White" weight="medium" size="200">
        {value}
      </Text>
    )
  }

  return (
    <MinutesToText
      value={value}
      color="grey000White"
      weight="medium"
      size="200"
      withPlusSign={false}
    />
  )
}

const PopoverRow = ({ label, value }: Props) => {
  const ref = React.useRef(null)

  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Box textAlign="left">
        <Text color="grey000White" weight="medium" size="200" ellipsis>
          {label}
        </Text>
      </Box>
      <Value value={value} />
    </Box>
  )
}

export default PopoverRow
